// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-dose-fab {
    /* Option buttons sit an equal gap apart, and the same gap above the main button. */
    --fab-size: 5.04rem;
    --option-size: 3.2rem;
    --option-gap: 0.8rem;
    position: absolute;
    right: 2.5rem;
    bottom: calc(1.5rem + env(safe-area-inset-bottom));
    width: var(--fab-size);
    height: var(--fab-size);
    z-index: 3;
}

.add-dose-fab .add-new-dose {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    border-width: 2px;
    background-color: var(--main-background-color);
    box-shadow: 0 0 0 0.4rem var(--main-background-color);
}

.add-dose-fab .add-new-dose .plus {
    transition: transform 0.2s ease;
}

.add-dose-fab.open .add-new-dose .plus {
    transform: rotate(45deg);
}

.add-dose-option {
    position: absolute;
    top: 50%;
    left: 50%;
    width: var(--option-size);
    height: var(--option-size);
    margin: calc(var(--option-size) / -2) 0 0 calc(var(--option-size) / -2);
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--main-foreground-color);
    border-radius: 50%;
    background-color: var(--main-background-color);
    color: var(--main-foreground-color);
    font-size: 1.3rem;
    font-weight: 600;
    cursor: pointer;
    opacity: 0;
    pointer-events: none;
    transform: translateY(0) scale(0.6);
    transition: opacity 0.15s ease, transform 0.2s ease;
}

.add-dose-fab.open .add-dose-option {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(calc(-1 * (
        (var(--fab-size) + var(--option-size)) / 2
        + var(--option-gap)
        + (var(--offset) - 1) * (var(--option-size) + var(--option-gap))
    ))) scale(1);
    transition-delay: calc(var(--offset) * 0.03s);
}

.add-dose-option.primary {
    color: var(--secondary-color);
}

.add-dose-fab .add-new-dose .plus::before,
.add-dose-fab .add-new-dose .plus::after {
    background-color: var(--secondary-color);
}

.add-dose-option:hover {
    background-color: var(--main-foreground-color);
    color: var(--main-background-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/AddDoseFab.css"],"names":[],"mappings":"AAAA;IACI,mFAAmF;IACnF,mBAAmB;IACnB,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,kDAAkD;IAClD,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,8CAA8C;IAC9C,qDAAqD;AACzD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,0BAA0B;IAC1B,uEAAuE;IACvE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8CAA8C;IAC9C,kBAAkB;IAClB,8CAA8C;IAC9C,mCAAmC;IACnC,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,oBAAoB;IACpB,mCAAmC;IACnC,mDAAmD;AACvD;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB;;;;gBAIY;IACZ,6CAA6C;AACjD;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;IACI,8CAA8C;IAC9C,mCAAmC;AACvC","sourcesContent":[".add-dose-fab {\n    /* Option buttons sit an equal gap apart, and the same gap above the main button. */\n    --fab-size: 5.04rem;\n    --option-size: 3.2rem;\n    --option-gap: 0.8rem;\n    position: absolute;\n    right: 2.5rem;\n    bottom: calc(1.5rem + env(safe-area-inset-bottom));\n    width: var(--fab-size);\n    height: var(--fab-size);\n    z-index: 3;\n}\n\n.add-dose-fab .add-new-dose {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    border-width: 2px;\n    background-color: var(--main-background-color);\n    box-shadow: 0 0 0 0.4rem var(--main-background-color);\n}\n\n.add-dose-fab .add-new-dose .plus {\n    transition: transform 0.2s ease;\n}\n\n.add-dose-fab.open .add-new-dose .plus {\n    transform: rotate(45deg);\n}\n\n.add-dose-option {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: var(--option-size);\n    height: var(--option-size);\n    margin: calc(var(--option-size) / -2) 0 0 calc(var(--option-size) / -2);\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--main-foreground-color);\n    border-radius: 50%;\n    background-color: var(--main-background-color);\n    color: var(--main-foreground-color);\n    font-size: 1.3rem;\n    font-weight: 600;\n    cursor: pointer;\n    opacity: 0;\n    pointer-events: none;\n    transform: translateY(0) scale(0.6);\n    transition: opacity 0.15s ease, transform 0.2s ease;\n}\n\n.add-dose-fab.open .add-dose-option {\n    opacity: 1;\n    pointer-events: auto;\n    transform: translateY(calc(-1 * (\n        (var(--fab-size) + var(--option-size)) / 2\n        + var(--option-gap)\n        + (var(--offset) - 1) * (var(--option-size) + var(--option-gap))\n    ))) scale(1);\n    transition-delay: calc(var(--offset) * 0.03s);\n}\n\n.add-dose-option.primary {\n    color: var(--secondary-color);\n}\n\n.add-dose-fab .add-new-dose .plus::before,\n.add-dose-fab .add-new-dose .plus::after {\n    background-color: var(--secondary-color);\n}\n\n.add-dose-option:hover {\n    background-color: var(--main-foreground-color);\n    color: var(--main-background-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
